import { Card, Skeleton, Typography } from "antd";
import React, { useState } from "react";
import { Doughnut } from "react-chartjs-2";

const { Text, Title } = Typography;

type Props = {
  loading?: any;
  percent: number;
  label?: string; // The label text, e.g., "VinCense"
  value?: number; // The value to display, e.g., 24000
};

const DashboardSmallCard: React.FC<Props> = ({
  label,
  value = 0,
  loading,
  percent = 0,
}) => {
  const data = {
    labels: ["Completed", "Remaining"],
    datasets: [
      {
        data: [value, 100 - (value || 0)],
        backgroundColor: ["#4CAF50", "#e0e0e0"],
        hoverBackgroundColor: ["#66BB6A", "#e0e0e0"],
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { display: false }, // Hide legend
      tooltip: { enabled: false }, // Disable tooltip for simplicity
    },
    cutout: "70%",
  };
  const percentage = percent ? Number((value / percent) * 100).toFixed(1) : 0;
  return (
    <>
      {loading ? (
        <Skeleton.Input active style={{ width: "170px", height: "190px" }} />
      ) : (
        <Card className="dashboard-small-card" bodyStyle={{ padding: 0 }}>
          <div className="dashboard-small-card-header">
            <Text
              style={{ color: "#666666", fontWeight: 500 }}
              className="dashboard-small-title"
            >
              {label}
            </Text>
          </div>
          <Title
            style={{ margin: 20, color: "#666666" }}
            className="dashboard-key-value"
          >
            {value}
          </Title>
          <div className="pie-chart-values">
            <Doughnut data={data} options={options} width={90} />
            <div className="small-card-percentage">{percentage}%</div>
          </div>
        </Card>
      )}
    </>
  );
};

export default DashboardSmallCard;
